/*
 * Copyright (c) 2021. Revo Digital
 * ---
 * Author: gabriele
 * File: BeforeExitOverlay.tsx
 * Project: mle-client
 * Committed last: 2021/11/22 @ 177
 * ---
 * Description:
 */

import {
  Button,
  Card,
  Classes,
  Divider,
  Intent,
  Overlay
}                             from '@blueprintjs/core';
import { MleToaster }         from '../../common/toast';
import React, { useCallback } from 'react';
import classNames             from 'classnames';
import { currentThemeIsDark } from '../../common/utils';
import { CenterBothAxes }     from '../common/layout/CenterBothAxes';
import { Editor }             from '../../store/observables/Editor';
import { observer }           from 'mobx-react';

interface Props {
  editor: Editor;
  onCancel: () => void;
  onSaveAndExit: () => void;
  onExitDiscard: () => void;
  visible: boolean;
}

export const ExitOptionsDialog = observer((props: Props) => {
  const onOverlayOpening = useCallback(() => {
    MleToaster.getInstance().clear();
  }, []);

  return (
    <Overlay
      isOpen={ props.visible }
      onClose={ props.onCancel }
      canEscapeKeyClose
      usePortal={ true }
      onOpening={ onOverlayOpening }
      className={ classNames(Classes.OVERLAY_SCROLL_CONTAINER,
        { 'bp4-dark': currentThemeIsDark() }) }
    >
      <CenterBothAxes>
        <Card className="mle-center-both-axes-child mx-auto w-72">
          <h5 className="bp4-heading">Opzioni chiusura progetto <div
            className="font-light">Persistenza modifiche</div></h5>
          <Divider className="my-4"/>
          <div className="my-2 bp4-text-muted">
            Stai per chiudere il
            progetto <strong>{ props.editor.projectData.title }</strong>,
            alcune modifiche potrebbero andare perse se non effettui il
            salvataggio.
          </div>
          <Divider className="my-4"/>
          <div className={ 'mx-auto space-y-2' }>
            <Button
              icon="floppy-disk"
              intent={ Intent.PRIMARY }
              onClick={ props.onSaveAndExit }
              className="w-full"
              loading={ props.editor.saveFeature.isSaving }
            >
              Salva ed esci
            </Button>
            <Button
              intent={ Intent.NONE }
              onClick={ props.onExitDiscard }
              className="w-full"
            >
              Esci senza salvare
            </Button>
            <Button
              intent={ Intent.NONE }
              onClick={ props.onCancel }
              className="w-full"
            >
              Annulla
            </Button>
          </div>
        </Card>
      </CenterBothAxes>
    </Overlay>
  );
});
